import { Box, CardMedia, Typography, useTheme } from '@mui/material';
import search_bell_icon from '@/assets/icons/map/search_bell.svg'

const Search = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        height: { xs: '11px', md: '19px', lg: '27px' },
        maxWidth: 'fit-content',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        borderRadius: { xs: '5px', md: '9px', lg: '13px' },
        backgroundColor: theme.palette.common.white,
        boxSizing: 'border-box',
        border: '0.5px solid rgba(0, 0, 0, 0.1)',
        paddingX: { xs: '5px', md: '7px', lg: '10px' }
      }}
    >
      <CardMedia 
        component='img'
        image={search_bell_icon}
        sx={{
          width: { xs: '6px', md: '8px', lg: '10px' },
          height: { xs: '6px', md: '8px', lg: '10px' },
          marginRight: '2px'
        }}
      />
      <Typography
        sx={{
          color: theme.palette.grey[500],
          fontSize: { xs: '0.25rem', md: '0.35rem', lg: '0.5rem' }
        }}
      >
        <Typography
          component='span'
          sx={{
            fontSize: { xs: '0.25rem', md: '0.35rem', lg: '0.5rem' },
            color: theme.palette.common.black
          }}
        >
          2022 Tesla
        </Typography>
        &nbsp;- Fuel is low: 10 gallons left in trunk, which equals 50
        miles distance. Please, refuel ASAP.
      </Typography>
    </Box>
  )
};

export default Search;